import Img from './img';

export default Img;
